// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"css-2VTD600F4-","button__newsletter":"css-1PCU86gA82","button__selected":"css-wFa9QfOCA3","button__disabled":"css-3J1jiEWNfm"};